module.exports = __webpack_public_path__ + "assets/img/small_gel_icon.f553646e.svg";